import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import times from 'lodash/times';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ISavedSearchData } from '@bvi/api-interfaces/response/case';
import { TableRowSkeleton } from '@bvi/common-components';
import { SavedSearchRow } from '@bvi/dashboard/feature/saved-searches/ui/saved-searches-table/saved-search-row';

import { styles } from './styles';

export interface ISavedSearchesTableProperties {
  savedSearches: Array<ISavedSearchData>;
  isLoading?: boolean;
}

export const SavedSearchesTable: FC<ISavedSearchesTableProperties> = ({
  savedSearches,
  isLoading,
}) => {
  const { t } = useTranslation();

  const tableColumns = [
    {
      title: t('savedSearches.table.columns.searchDates'),
      width: '250px',
    },
    {
      title: t('savedSearches.table.columns.userName'),
      width: 'auto',
    },
    {
      title: null,
      width: '170px',
    },
    {
      title: null,
      width: '180px',
    },
    {
      title: null,
      width: '220px',
    },
  ];

  return (
    <TableContainer component={Paper}>
      <Table size="small" sx={styles.fixedTable}>
        <TableHead>
          <TableRow>
            {tableColumns.map((column, index) => (
              <TableCell key={index} width={column.width}>
                {column.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading
            ? times(2, (index) => <TableRowSkeleton columns={4} key={index} />)
            : savedSearches.map((savedSearch) => (
                <SavedSearchRow
                  key={`saved-search-${savedSearch.id}`}
                  savedSearch={savedSearch}
                />
              ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
